const CreateFormModalTestIdsScope = {
  CREATE_FORM_MODAL: 'create-form-modal',
};

export const CreateFormModalTestIds = {
  DISCLOSURE_TYPE_SELECT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.disclosure-type-select`,
  PURPOSE_TYPE_SELECT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.purpose-type-select`,
  FORM_PURPOSE_SELECT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.form-purpose-select`,
  UPLOAD_PDF_CHECKBOX: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.upload-pdf-checkbox`,
  WITH_PAGE_NUMBERS_CHECKBOX: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.with-page-numbers-checkbox`,
  FORM_APPLICATION_TYPE_SELECT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.form-application-type-select`,
  SUBMIT_BUTTON: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.submit-button`,
  NAME_INPUT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.name-input`,

  // CreateFormModal (inline)
  CREATE_FORM_MODAL_FORMS_CREATE_FORM_AUTOCOMPLETE_SELECT: `${CreateFormModalTestIdsScope.CREATE_FORM_MODAL}.forms-create-form-autocomplete-select`,
};
